//site users
export type UserRoles =
  | "Admin"
  | "Manager"
  | "Cashier"
  | "Supervisor"
  | "Accountant"
  | "Acountant"
  | "Labor"
  | "System Admin"
  | "admin"
  | "manager"
  | "cashier"
  | "supervisor"
  | "acountant"
  | "labor"
  | "none";

export enum UserRolesEnum {
  Admin = "Admin",
  Manager = "Manager",
  Cashier = "Cashier",
  Supervisor = "Supervisor",
  Accountant = "Accountant",
  Acountant = "Acountant",
  Labor = "Labor",
  SystemAdmin = "System Admin",
  admin = "admin",
  manager = "manager",
  cashier = "cashier",
  supervisor = "supervisor",
  acountant = "acountant",
  labor = "labor",
  none = "none",
}
export interface UserType {
  userId: any;
  username: string;
  userRole: UserRoles;
}
